import { Navbar } from "./Navbar";

const adminPages = [
  { title: "Klienter", route: "clients" },
  { title: "Slutkunder", route: "endcustomers" },
];

export function AdminNavbar() {
  return <Navbar pages={adminPages} />;
}
